import { z } from "zod";

export const schema = z.object({
	id_tipoproduto: z
		.number()
		.int("Verifique o id_categoria antes de continuar"),
	ordem: z.preprocess(
		(val) => {
			if (typeof val === "string") {
				return parseInt(val, 10); // Tenta converter a string para um número inteiro
			}
			return val;
		},
		z
			.number({
				required_error: "A quantidade é obrigatória",
				invalid_type_error: "A quantidade deve ser um número",
			})
			.int("A quantidade deve ser um número inteiro")
			.min(0, "A quantidade deve ser 0 ou maior")
		// .positive("A quantidade deve ser positiva")
	),

	nome: z.string().min(1, "Campo nome é obrigatório"),
	ativo: z.boolean(),
	obs: z.string().nullable(),
});
